import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { ApolloService } from '../services/apollo.service';


@Injectable({
  providedIn: 'root',
})
export class VesselsService {

  addShipfilterval:any;
  
  addSubpoolfilterval:any;
  _vesselNumber:any;
  addShipdateselected:any;
  pointsVal:any
  scrubberPointsval:any
  serachShipData:any = [];
  newSearchshipdata:any;
  scrubberToggleval:boolean = false;
  lngToggleval:boolean = false;
  showDatestatus:boolean = false;
  getFleetval:any;
  callSubmitship = new BehaviorSubject<boolean>(false);
  navigateFleetlist = new BehaviorSubject<boolean>(false);
  storePoolval:any;
  storegetPoolData:any = [];
  filterdFleetShipNames:any = [];
  filteredFleetShipOwner:any = [];
  filteredFleetStatus:any = [];
  cancelPenalty = new BehaviorSubject<boolean>(false);
  saveSelectedTab = new BehaviorSubject<boolean>(false);
  $pointsMngEvent = new BehaviorSubject<boolean>(false);
  get vesselNumber(): string | null {
    if (!this._vesselNumber) {
      this._vesselNumber = sessionStorage.getItem('vslNumber');
    }
    return this._vesselNumber;
  }
  set vesselNumber(value: string | null) {
    this._vesselNumber = value;
    if (value) {
      sessionStorage.setItem('vslNumber', value);
    } else {
      sessionStorage.removeItem('vslNumber');
    }
  }
  constructor(private apolloService: ApolloService) { 
  }

  getVessels(filter: any): Observable<any> {
     
    const query = `
          query GetVessels($filter: VesselFilter) {
            getVessels(filter: $filter) {
              success
              vessels {
                fleet
            vslCode
            vslNumber
            vslName
            vslOwner
            vslClass
            subPool
            poolPoint
            updatedPoolPoint
            poolPointEffectiveFrom
            penaltyValue
            penaltyEffectiveDate
            penaltyEffectiveTime
            penaltyReason
            penaltyCloseEffectiveDate
            penaltyCloseEffectiveTime
            iActive
            isPending
            status
            updatedStatus
            createdAt
            updatedAt
            statusEffectiveFrom
            lastUpdatedAtByUser
            lastUpdatedByUser
            lastUpdatedByFirstName
            lastUpdatedByLastName
            lastUpdatedByInitials
              }
              message
              statusCode
              success
            }
          }
        `;

    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getSubPools(): Observable<any> {
    const query = `
            query Query {
                getSubPools {
                message
                statusCode
                success
                data 
                }
            }
        `;


    return this.apolloService.query(query).valueChanges
  }

  getSubpoolVessels(filter: any) {
    const query = `
        query GetVesselsVessel($filter: VesselFilter) {
            getVessels(filter: $filter) {
            message
              statusCode
              success
              vessels {
                fleet
                vslCode
                vslNumber
                vslName
                vslOwner
                vslClass
                subPool
                poolPoint
                iActive
                isNew
                scrubberFitted
                scbrPoints
                createdAt
                updatedAt
                penaltyValue
                penaltyEffectiveDate
                penaltyEffectiveTime
                penaltyReason
                penaltyCloseEffectiveDate
                penaltyCloseEffectiveTime
                poolPointEffectiveFrom
                updatedPoolPoint
                updatedStatus
              }
            }
          }
        `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  validateVessel(vslNumber: any): Observable<any> {
    const query = `
        query ValidateVessel($vslNumber: String) {
            validateVessel(vslNumber: $vslNumber) {
              gvsls
              message
              statusCode
              success
            }
          }
        `;
    return this.apolloService.query(query, { vslNumber: vslNumber }).valueChanges
  }
  getAddSubpoolVessels(input:any): Observable<any> {
    const query = `
      query GetAddVesselList($input: filterInput) {
        getAddVesselList(input: $input) {
          data {
            vslClass
            vslType
            vslName
            vslCode
            vslNumber
            scrubberType
            lng
          }
          message
          statusCode
          success
        }
      }
      `;
    return from(this.apolloService.query(query).refetch({ input: input }));
  }

  createVessels(vessels: any) {
    const query = `
        mutation CreateVessel($input: [CreateVesselInput!]!) {
          createVessel(input: $input) {
            success
            statusCode
            message
            vessel {
              vesselCreated
              vesselUpdated
              norUpdatedOrCreated
            }
          }
        }
       `;
    return this.apolloService.mutate(query, { input: vessels })
  }

  addUpdatePenaltyData(input: any): Observable<any> {
    const query = `
          mutation AddUpdatePenaltyData($input: PenaltyInput!) {
            addUpdatePenaltyData(input: $input) {
              data{
                vslNumber
                penaltyValue
                penaltyEffectiveDate
                penaltyEffectiveTime
                penaltyReason
                penaltyCloseEffectiveDate
                penaltyCloseEffectiveTime
              }
              success
              statusCode
              message
            }
          }
      `;
    return this.apolloService.mutate(query, { input: input })
  }

  updatePoolPointData(input: any): Observable<any> {
    const query = `
			mutation UpdatePoolPointData($input: PoolPointInput!) {
				updatePoolPointData(input: $input) {
				data{
					poolPointEffectiveFrom
					poolPoint
					vslNumber
					vslOwner
          
				}
				success
				statusCode
				message
				}
			}
      `;
    return this.apolloService.mutate(query, { input: input })
  }

  getVesselChangeLog(filter): Observable<any> {
    const query = `
    query GetVesselChangeLog($filter: VesselChangeLogFilter) {
      getVesselChangeLog(filter: $filter) {
        message
        statusCode
        success
        wefPoolPoint
        logCount
        vesselChangeLog {
          vslCode
          vslNumber
          comment
          action
          effectiveDate
          endDate
          changedBy
          createdAt
          updatedAt
        }
      }
    }
    `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getVesselChangeLogByAction(filter): Observable<any> {
    const query = `
    query GetChangeLogLatestDataByAction($filter: VesselStatusChangeLogFilter) {
      getChangeLogLatestDataByAction(filter: $filter) {
        message
        statusCode
        success
        vesselChangeLog {
          action
          comment
          createdAt
          effectiveDate
          vslNumber
          reason
        }
      }
    }
    `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  changeVesselsStatus(input: any): Observable<any> {
    const query = `
      mutation ActiveInactiveVessel($input: ActiveInactiveInput) {
        activeInactiveVessel(input: $input) {
          message
          statusCode
          success
          vslNumber
        }
      }
    `;
    return this.apolloService.mutate(query, { input: input })
  }

  getVesselDetail(vslNumber: any) {
    const query = `
    query GetVessel($vslNumber: String) {
      getVessel(vslNumber: $vslNumber) {
          success 
          statusCode
          message
          vessel {
          fleet
          shipStatus
          vslCode
          vslNumber
          vslName
          vslOwner
          vslClass
          subPool
          poolPoint
          updatedPoolPoint
          poolPointEffectiveFrom
          penaltyValue
          penaltyPercentage
          penaltyEffectiveDate
          penaltyEffectiveTime
          penaltyReason
          penaltyCloseEffectiveDate
          penaltyCloseEffectiveTime
          iActive
          isPending
          status
          isNew
          scrubberFitted
          scbrPoints
          updatedStatus
          updatedStatusReason
          statusEffectiveFrom
          createdAt
          updatedAt
          adjustOpdays
          scrubberType
          lng
          updatedScbrPoints
          scbrPointsEffectiveFrom
          scbrPointsReason
          lastUpdatedAtByUser
          lastUpdatedByUser
          lastUpdatedByFirstName
          lastUpdatedByLastName
          lastUpdatedByInitials
          isPenaltyOngoing
          vesselActivationDate
          statusInfo {
            currentStatus
            futureChange
            pastOrTodayChange
            updatedStatus
            effectiveDate
            upcomingStatus
            upcomingEffectiveDate
            previousStatus
            previousActivationDate
            nextCalculationDate
            wasPreviouslyInactive
          }
          }
        }
      }
        `;
    return from(this.apolloService.query(query).refetch({ vslNumber: vslNumber }));
  }

  getDashboardFilters(filter) {
    const query = `
      query GetDashboardFilters($filter: DashboardFilter) {
        getDashboardFilters(filter: $filter) {
          message
          statusCode
          success
          data {
            vslName
            subPool
            vslOwner
            vslClass
          }
        }
      }
    `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  revertPoolPoints(vslNumber: string): Observable<any> {
    const query = `
      mutation RevertPoolPoints($vslNumber: String) {
        revertPoolPoints(vslNumber: $vslNumber) {
          message
          statusCode
          success
        }
      }
    `;
    return this.apolloService.mutate(query, { vslNumber: vslNumber })
  }

  revertPenalty(vslNumber: string): Observable<any> {
    const query = `
      mutation RevertPenalty($vslNumber: String) {
        revertPenalty(vslNumber: $vslNumber) {
          message
          statusCode
          success
        }
      }
    `;
    return this.apolloService.mutate(query, { vslNumber: vslNumber })
  }

  revertClosePenalty(vslNumber: string): Observable<any> {
    const query = `
      mutation RevertClosePenalty($vslNumber: String) {
        revertClosePenalty(vslNumber: $vslNumber) {
          message
          statusCode
          success
        }
      }
    `;
    return this.apolloService.mutate(query, { vslNumber: vslNumber })
  }

  revertStatus(vslNumber: string): Observable<any> {
    const query = `
      mutation RevertStatus($vslNumber: String) {
        revertStatus(vslNumber: $vslNumber) {
          message
          statusCode
          success
        }
      }
    `;
    return this.apolloService.mutate(query, { vslNumber: vslNumber })
  }

  deleteVessel(vslNumber: string): Observable<any> {
    const query = `
      mutation DeleteVessel($vslNumber: String!) {
        deleteVessel(vslNumber: $vslNumber) {
          message
          statusCode
          success
        }
      }
    `;
    return this.apolloService.mutate(query, { vslNumber: vslNumber })
  }

  getShowScrubberLNG(filter: any): Observable<any> {     
    const query = `query ShowScrubberLNG($fleet: String) {
      showScrubberLNG(fleet: $fleet) {
        success
        statusCode
        message
        data{
          showScrubberSavings
          showLNGSavings
        }
      }
    }`;

    return from(this.apolloService.query(query).refetch({ fleet: filter }));
  }

  // getshipDetails(filter:any): Observable<any>{
  //  const query = `  
  //   query {
  // getVessel(vslNumber: "T0T0246") {
  //   success
  //   statusCode
  //   message
  //   vessel {
  //     vslNumber
  //     vslName
  //     fleet
  //     vslOwner
  //     vslClass
  //     poolPoint
  //     updatedPoolPoint
  //     poolPointEffectiveFrom
  //     penaltyValue
  //     penaltyEffectiveDate
  //     penaltyEffectiveTime
  //     penaltyReason
  //     penaltyCloseEffectiveDate
  //     penaltyCloseEffectiveTime
  //     iActive
  //     isNew
  //     scrubberFitted
  //     scbrPoints
  //     updatedStatus
  //     updatedStatusReason
  //     statusEffectiveFrom
  //     createdAt
  //     updatedAt
  //     adjustOpdays
  //     scrubberType
  //     lng
  //     updatedScbrPoints
  //     scbrPointsEffectiveFrom
  //     scbrPointsReason
  //   }`;
  //   return from(this.apolloService.query(query).refetch({ filter: filter }));
  // }

  addShipsubmit(input:any){
   const query =  `mutation AddShip($input: AddShipInput!) {
    addShipToFleet(input: $input) {
      success
      statusCode
      message
      vessel {
        vesselCreated
        vesselUpdated
        norUpdatedOrCreated
      }
    }
    }`;
    return this.apolloService.mutate(query, { input: input })
  }

  addPenalty(input:any){
  const query =  `mutation AddPenalty($input: AddPenaltyInput!) {
  addPenalty(input: $input) {
   success
   statusCode
   message
    data {
        vslCode
        vslNumber
        penaltyValue
        penaltyPercentage
        penaltyEffectiveDate
        penaltyEffectiveTime
        penaltyReason
      }
    }
  }`;
    return this.apolloService.mutate(query, { input: input })
  }


  endPenalty(input:any){
  const query =  `mutation EndPenalty($input: EndPenaltyInput!) {
  endPenalty(input: $input) {
   success
    statusCode
    message
    data {
      vslCode
      vslNumber
      penaltyValue
      penaltyPercentage
      penaltyCloseEffectiveDate
      penaltyCloseEffectiveTime
      penaltyReason
    }
  }
  }
  `;
    return this.apolloService.mutate(query, { input: input })
  }

  removePenalty(input:any){
  const query =  `mutation RemovePenalty($input: RemovePenaltyInput!) {
    removePenalty(input: $input) {
      success
      statusCode
      message
      data {
        vslCode
        vslNumber
        penaltyValue
        penaltyPercentage
        penaltyCloseEffectiveDate
        penaltyCloseEffectiveTime
        penaltyReason
      }
    }
    }
  `;
    return this.apolloService.mutate(query, { input: input })
  }

  removePenaltyOnPageLoad(input:any): Observable<any> {
    const query = `
    query RemovePenaltyPageLoad($input: RemovePenaltyPageLoadInput!) {
    removePenaltyPageLoad(input: $input) {
      success
      statusCode
      message
      data {
        penaltyValue
        penaltyPercentage
        penaltyEffectiveDate
        penaltyEffectiveTime
        penaltyCloseEffectiveDate
        penaltyCloseEffectiveTime
        penaltyReason
        hasActivePenalty
        alreadyUsedInCalculation
        effectedMonths
        penaltyHistory {
          penaltyValue
          effectivePoolPoints
          from
          to
          duration
          status
          penaltyReason
          showRemoveButton
          penaltyRemovalReason
          penaltyRemovalDate
          lastUpdatedAt
          lastUpdatedBy
        }
      }
    }
    }`;
    return from(this.apolloService.query(query).refetch({ input: input }));
  }


  getPoolPointDetails(filter: any): Observable<any> {
    const query = `
            query GetPoolPointDetails($vslNumber: String) {
              getPoolPointDetails(vslNumber: $vslNumber){
              data {
                  hasPreviousChange
                  status
                  currentPoolPoint
                  currentEffectiveDate,
                  currentReason
                  upComingPoolPoint
                  upcomingEffectiveDate,
                  upcomingReason
                  previousPoolPoint
                  previousEffectiveDate,
                  previousReason
                  nextCalculationDate,
                  vesselActivationDate
              }
              message
              success
              statusCode
              }
          }
        `;

    return from(this.apolloService.query(query).refetch(filter));
  }

  getPenaltyHistory(filter: any): Observable<any> {
    const query = `
        query GetPenaltyHistory($vslCode: String!) {
        getPenaltyHistory(vslCode: $vslCode) {
          success
          statusCode
          message
          data {
            penaltyValue
            effectivePoolPoints
            from
            to
            duration
            status
            penaltyReason
            showRemoveButton
            penaltyRemovalReason
            penaltyRemovalDate
            lastUpdatedAt
            lastUpdatedBy
            lastUpdatedAtByUser
            lastUpdatedByUser
            lastUpdatedByFirstName
            lastUpdatedByLastName
            lastUpdatedByInitials
            alreadyUsedInCalculation
            effectedMonths

          }
        }
        }
        `;

    return from(this.apolloService.query(query).refetch(filter));
  }
  discardPoolPoints(input:any){
    const query =  `mutation DiscardPoolPointDetails($input: DiscardPoolPointInput!) {
      discardPoolPointDetails(input: $input) {
        success
        statusCode
        message
        data {
            poolPointDetails{
              hasPreviousChange
              status
              currentPoolPoint
              currentEffectiveDate
              currentReason
              upComingPoolPoint
              upcomingEffectiveDate
              upcomingReason
              previousPoolPoint
              previousEffectiveDate
              previousReason
              nextCalculationDate
              vesselActivationDate
              }
          }
        }
      }

    `;
    return this.apolloService.mutate(query, { input: input })
  }
  updatePoolPointDetails(input: any): Observable<any> {
    const query = `
			mutation UpdatePoolPointDetails($input: PoolPointInput!) {
        updatePoolPointDetails(input: $input) {
        data{
          poolPointEffectiveFrom
          poolPoint
          vslNumber
          poolPointDetails{
            hasPreviousChange
            status
            currentPoolPoint
            currentEffectiveDate
            currentReason
            upComingPoolPoint
            upcomingEffectiveDate
            upcomingReason
            previousPoolPoint
            previousEffectiveDate
            previousReason
            nextCalculationDate
            vesselActivationDate
            }
          }
        success
        statusCode
        message
        }
      }
      `;
    return this.apolloService.mutate(query, { input: input })
  }

  revertPoolPointDetails(input: any): Observable<any> {
    const query = `
			mutation RevertPoolPointDetails($input: RevertPoolPointInput!) {
      revertPoolPointDetails(input: $input) {
        success
        statusCode
        message
        data {
          poolPointDetails{
            hasPreviousChange
            status
            currentPoolPoint
            currentEffectiveDate
            currentReason
            upComingPoolPoint
            upcomingEffectiveDate
            upcomingReason
            previousPoolPoint
            previousEffectiveDate
            previousReason
            nextCalculationDate
            vesselActivationDate
          }
        }
      }
    }
      `;
    return this.apolloService.mutate(query, { input: input })
  }

  getScrubberPointDetails(filter: any): Observable<any> {
    const query = `
      query GetScrubberPointDetails($vslNumber: String) {
        getScrubberPointDetails(vslNumber: $vslNumber){
        data {
            hasPreviousChange
            status
            currentScrubberPoint
            currentEffectiveDate,
            currentReason
            upComingScrubberPoint
            upcomingEffectiveDate,
            upcomingReason
            previousScrubberPoint
            previousEffectiveDate,
            previousReason
            nextCalculationDate,
            vesselActivationDate
        }
        message
        success
        statusCode
        }
    }
        `;

    return from(this.apolloService.query(query).refetch(filter));
  }
  updateScrubberPointDetails(input: any): Observable<any> {
    const query = `
		mutation UpdateScrubberPointDetails($input: ScrubberPointInput!) {
        updateScrubberPointDetails(input: $input) {
        data{
            scrubberPointEffectiveFrom
            scrubberPoint
            vslNumber
            scrubberPointDetails{
                hasPreviousChange
                status
                currentScrubberPoint
                currentEffectiveDate
                currentReason
                upComingScrubberPoint
                upcomingEffectiveDate
                upcomingReason
                previousScrubberPoint
                previousEffectiveDate
                previousReason
                nextCalculationDate
                vesselActivationDate
            }
        }
        success
        statusCode
        message
    }
}
      `;
    return this.apolloService.mutate(query, { input: input })
  }
  discardScrubberPoints(input:any){
    const query =  `mutation DiscardScrubberPointDetails($input: DiscardScrubberPointInput!) {
    discardScrubberPointDetails(input: $input) {
        success
        statusCode
        message
        data {
            scrubberPointDetails{
                hasPreviousChange
                status
                currentScrubberPoint
                currentEffectiveDate
                currentReason
                upComingScrubberPoint
                upcomingEffectiveDate
                upcomingReason
                previousScrubberPoint
                previousEffectiveDate
                previousReason
                nextCalculationDate
                vesselActivationDate
            }
        }
    }
  }

    `;
    return this.apolloService.mutate(query, { input: input })
  }
  revertScrubberPointDetails(input: any): Observable<any> {
    const query = `
			mutation RevertScrubberPointDetails($input: RevertScrubberPointInput!) {
    revertScrubberPointDetails(input: $input) {
        success
        statusCode
        message
        data {
            scrubberPointDetails{
                hasPreviousChange
                status
                currentScrubberPoint
                currentEffectiveDate
                currentReason
                upComingScrubberPoint
                upcomingEffectiveDate
                upcomingReason
                previousScrubberPoint
                previousEffectiveDate
                previousReason
                nextCalculationDate
                vesselActivationDate
            }
        }
    }
}
      `;
    return this.apolloService.mutate(query, { input: input })
  }
  // ----edit overvew status----
  getEditStatusDetails(filter: any): Observable<any> {
    const query = `
        query GetVesselStatusForEdit($vslNumber: String!) {
        getVesselStatusForEdit(vslNumber: $vslNumber) {
          success
          statusCode
          message
          data {
            vslNumber
            currentStatus
            currentActivationDate
            currentReason
            fiscalYear {
              start
              end
            }
            upcomingChange {
              status
              effectiveDate
              reason
            }
            previousStatus
            previousActivationDate
            previousReason
            futureChange
            pastOrTodayChange
            nextCalculationDate
            wasPreviouslyInactive
          }
        }
        } `;

    return from(this.apolloService.query(query).refetch(filter));
  }
  updateEditStatus(input: any): Observable<any> {
    const query = `
		mutation UpdateVesselStatus($input: UpdateVesselStatusInput!) {
      updateVesselStatus(input: $input) {
        success
        statusCode
        message
        data {
          currentStatus,
          currentReason,
          currentActivationDate,
          futureChange,
          pastOrTodayChange,
          upcomingChange {
            status,
            effectiveDate,
            reason
          },
          previousStatus,
          previousActivationDate,
          previousReason,
          nextCalculationDate,
          wasPreviouslyInactive
        }
      }
    }
      `;
    return this.apolloService.mutate(query, { input: input })
  }
  discardEditStatus(input:any){
    const query =  `mutation DiscardVesselStatus($input: DiscardVesselStatusInput!) {
      discardVesselStatus(input: $input) {
        success
        statusCode
        message
        data {
          currentStatus,
          currentReason,
          currentActivationDate,
          futureChange,
          pastOrTodayChange,
          upcomingChange {
            status,
            effectiveDate,
            reason
          },
          previousStatus,
          previousActivationDate,
          previousReason,
          nextCalculationDate,
          wasPreviouslyInactive
        }
      }
      }
    `;
    return this.apolloService.mutate(query, { input: input })
  }
  revertEditStatusDetails(input: any): Observable<any> {
    const query = `
			mutation RestoreVesselStatus($input: RestoreVesselStatusInput!) {
      restoreVesselStatus(input: $input) {
        success
        statusCode
        message
        data {
          currentStatus,
          currentReason,
          currentActivationDate,
          futureChange,
          pastOrTodayChange,
          upcomingChange {
            status,
            effectiveDate,
            reason
          },
          previousStatus,
          previousActivationDate,
          previousReason,
          nextCalculationDate,
          wasPreviouslyInactive
        }
      }
    }`;
    return this.apolloService.mutate(query, { input: input })
  }

  // ----edit lng usage-----

  getLngDetails(filter: any): Observable<any> {
    const query = `
      query GetLngDetails($vslNumber: String) {
        getLngDetails(vslNumber: $vslNumber){
        data {
            hasPreviousChange
            status
            currentLng
            currentEffectiveDate,
            currentReason
            upComingLng
            upcomingEffectiveDate,
            upcomingReason
            previousLng
            previousEffectiveDate,
            previousReason
            nextCalculationDate,
            vesselActivationDate
        }
        message
        success
        statusCode
        }
    }
        `;

    return from(this.apolloService.query(query).refetch(filter));
  }

  updateLngDetails(input: any): Observable<any> {
    const query = `
        mutation UpdateLngDetails($input: LngInput!) {
        updateLngDetails(input: $input) {
        data{
            lngEffectiveFrom
            lng
            vslNumber
            lngDetails{
                hasPreviousChange
                status
                currentLng
                currentEffectiveDate
                currentReason
                upComingLng
                upcomingEffectiveDate
                upcomingReason
                previousLng
                previousEffectiveDate
                previousReason
                nextCalculationDate
                vesselActivationDate
            }
        }
        success
        statusCode
        message
      }
    }
      `;
    return this.apolloService.mutate(query, { input: input })
  }

  discardLngDetails(input:any){
    const query =  `mutation DiscardLngDetails($input: DiscardLngInput!) {
      discardLngDetails(input: $input) {
        success
        statusCode
        message
        data {
          lngDetails{
            hasPreviousChange
            status
            currentLng
            currentEffectiveDate
            currentReason
            upComingLng
            upcomingEffectiveDate
            upcomingReason
            previousLng
            previousEffectiveDate
            previousReason
            nextCalculationDate
            vesselActivationDate
          }
        }
      }
    }

    `;
    return this.apolloService.mutate(query, { input: input })
  }
  revertLngDetails(input: any): Observable<any> {
    const query = `
			mutation RevertLngDetails($input: RevertLngInput!) {
      revertLngDetails(input: $input) {
        success
        statusCode
        message
        data {
        lngDetails{
          hasPreviousChange
          status
          currentLng
          currentEffectiveDate
          currentReason
          upComingLng
          upcomingEffectiveDate
          upcomingReason
          previousLng
          previousEffectiveDate
          previousReason
          nextCalculationDate
          vesselActivationDate
        }
      }
    }
  }
      `;
    return this.apolloService.mutate(query, { input: input })
  }

  // ----edit scrubber usage----

  getScrubberUsageDetails(filter: any): Observable<any> {
    const query = `
    query GetScrubberUsageDetails($vslNumber: String) {
    getScrubberUsageDetails(vslNumber: $vslNumber) {
      data {
        hasPreviousChange
        status
        currentScrubberUsage
        currentScrubberPoints
        currentEffectiveDate
        currentReason
        upcomingScrubberUsage
        upcomingScrubberPoints
        upcomingEffectiveDate
        upcomingReason
        previousScrubberUsage
        previousScrubberPoints
        previousEffectiveDate
        previousReason
        nextCalculationDate
        vesselActivationDate
      }
      message
      success
      statusCode
    }
    }  `
    ;

    return from(this.apolloService.query(query).refetch(filter));
  }
  updateScrubberDetails(input: any): Observable<any> {
    const query = `
    mutation UpdateScrubberUsage($input: ScrubberUsageInput!) {
    updateScrubberUsageDetails(input: $input) {
      success
      statusCode
      message
      data {
        hasPreviousChange
        status
        currentScrubberUsage
        currentScrubberPoints
        currentEffectiveDate
        currentReason
        upcomingScrubberUsage
        upcomingScrubberPoints
        upcomingEffectiveDate
        upcomingReason
        previousScrubberUsage
        previousScrubberPoints
        previousEffectiveDate
        previousReason
        nextCalculationDate
        vesselActivationDate
      }
    }
    }
      `;
    return this.apolloService.mutate(query, { input: input })
  }
  discardScrubberDetails(input:any){
    const query =  `mutation DiscardScrubberUsage($input: DiscardScrubberUsageInput!) {
    discardScrubberUsageDetails(input: $input) {
      success
      statusCode
      message
      data {
        hasPreviousChange
        status
        currentScrubberUsage
        currentScrubberPoints
        currentEffectiveDate
        currentReason
        upcomingScrubberUsage
        upcomingScrubberPoints
        upcomingEffectiveDate
        upcomingReason
        previousScrubberUsage
        previousScrubberPoints
        previousEffectiveDate
        previousReason
        nextCalculationDate
        vesselActivationDate
      }
    }
    }

    `;
    return this.apolloService.mutate(query, { input: input })
  }
  revertSCrubberDetails(input: any): Observable<any> {
    const query = `
			mutation RevertScrubberUsage($input: RevertScrubberUsageInput!) {
      revertScrubberUsageDetails(input: $input) {
        success
        statusCode
        message
        data {
          hasPreviousChange
          status
          currentScrubberUsage
          currentScrubberPoints
          currentEffectiveDate
          currentReason
          upcomingScrubberUsage
          upcomingScrubberPoints
          upcomingEffectiveDate
          upcomingReason
          previousScrubberUsage
          previousScrubberPoints
          previousEffectiveDate
          previousReason
          nextCalculationDate
          vesselActivationDate
        }
      } 
    }  `;
    return this.apolloService.mutate(query, { input: input })
  }

 

  
}
  